import { Component, Input, ViewChild } from '@angular/core';
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { FormData } from 'src/app/framework-modules/formdata/form/formData';
import { RouterService } from 'src/app/services/routerService';
import { LoginForm, LoginFd } from 'src/app/framework-modules/formdata/gen/loginForm';
import { NonSessionComponent } from '../../component';
import { DynamicPanel, GroupPanel } from '../../interfaces';
import { CtSpinner } from 'src/app/framework-modules/elements/ct-spinner/component';
import { MessageService } from 'src/app/services/messageService';
import { ClientContext } from 'src/app/framework-modules/formdata/form/clientContext';

@Component({
  selector: 'login',
  templateUrl: './component.html',
  styleUrls: ['./component.scss']
})
export class LoginComponent implements DynamicPanel {
  @ViewChild("CtSpinner", { static: false }) public CtSpinner: CtSpinner;
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session: NonSessionComponent;

  public form: LoginForm;
  public fd: LoginFd;
  public constructor(public sa: ServiceAgent,
    public routerService: RouterService,
    private ms: MessageService,
    private clientContext: ClientContext) {
    this.form = LoginForm.getInstance();
    this.fd = new FormData(this.form, this.sa);
  }
  /**
   * Login Function
   */
  doLogin() {
    this.CtSpinner.show('Logging In.......');
    this.fd.save().subscribe(
      data => {
        this.clientContext.login(data);
        console.log("Login successful");
        this.routerService.openSession();
        this.CtSpinner.hide();
      },
      err => {
        this.CtSpinner.hide();
        this.checkError(err);
      }
    );
  }

  /**
   * Rgister Function
   */
  doRegister() {
    this.parentPanel.navigate('StaffRegistration')
  }

  /**
   * open forgot password page
   */
  openForgotPassword() {
    this.parentPanel.navigate('StaffRegistration')
  }

  checkError(error: any) {
    console.log(error.status)
    if (error.status != undefined) {
      this.ms.showError('Sorry! There is something wrong on our end! We are working on it');
      return
    }
    this.ms.showError('Invalid Username or Password, Please Try again')
  }
}
